import React from "react";

export default (props) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 6.24 6.24"
    enableBackground="new 0 0 6.24 6.24"
  >
    <path
      fill={props.color}
      d="m3.241,6.24c0.628,0 1.124-0.15 1.49-0.452 0.367-0.301 0.55-0.738 0.55-1.309 0-0.383-0.107-0.719-0.32-1.007-0.213-0.289-0.507-0.473-0.88-0.553 0.286-0.105 0.516-0.268 0.691-0.486 0.176-0.219 0.263-0.467 0.263-0.744 0-0.563-0.182-0.985-0.547-1.267-0.365-0.281-0.87-0.422-1.514-0.422h-2.015v6.24h2.282zm.123-2.923c0.368,0 0.64,0.104 0.816,0.312 0.177,0.207 0.265,0.494 0.265,0.858 0,0.347-0.106,0.615-0.318,0.805-0.212,0.19-0.507,0.284-0.886,0.284h-1.446v-2.259h1.569zm-1.569-2.652h1.179c0.396,0 0.699,0.084 0.91,0.251 0.21,0.167 0.316,0.419 0.316,0.756 0,0.308-0.098,0.549-0.293,0.722-0.195,0.173-0.448,0.259-0.759,0.259h-1.353v-1.988z"
    />
  </svg>
);
